import { render, staticRenderFns } from "./AccountUserInfo.vue?vue&type=template&id=06953c81&scoped=true&lang=pug&"
import script from "./AccountUserInfo.vue?vue&type=script&lang=js&"
export * from "./AccountUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountUserInfo.vue?vue&type=style&index=0&id=06953c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06953c81",
  null
  
)

export default component.exports